module.exports = __webpack_public_path__ + "img/syukyaku-dtp-001.c50e214e.jpg";